// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-chat[data-v-0a31773b]{background-size:cover;background-position:bottom;background-image:url(/img/productos/bg_chat.jpg)!important}.f-h[data-v-0a31773b]{height:93vh}.my_divider[data-v-0a31773b]{border:3px solid;border-radius:2px;max-width:5rem;width:40px}", ""]);
// Exports
module.exports = exports;
